import {
  Form,
  Input,
  ModalProps,
  FormProps,
  Modal,
  Row,
  Col,
  Select,
  InputNumber,
  Button,
  Space,
  useSelect,
  Collapse,
  Typography,
  Descriptions,
  Radio,
  ImportButton,
  useImport,
  message,
  Upload,
  Icons,
} from '@pankod/refine-antd'
import { CSVLink } from 'react-csv'
import { UploadOutlined } from '@ant-design/icons'
import { CrudFilter, CrudFilters, useCreateMany, useGetIdentity, useList, useMany, useTable } from '@pankod/refine-core'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import {
  IProduct,
  ITestTrack,
  ISection,
  ITopic,
  ITheme,
  ISubTheme,
  ISubject,
  IPaperTemplateSubSection,
  IQuestionType,
  IReportTheme,
} from 'interfaces'
import { v4 as uuidv4 } from 'uuid'
import { useEffect, useState } from 'react'
import { getLastCreatedPaperTemplate } from 'gql/mutations'
import { getThemeDataBySubjects, getReportThemeDataBySubjects, getSubThemeBySubjects, getTopicBySubjects } from 'gql/query'
import { isNull } from 'util'
import { checkMarkWithSectionTotal } from 'helpers/paperTemplate/checkingTotalMarks'
import { paperTemplateImportFomart } from 'helpers/import_template_format/importTemplate'
import { IPaperTemplateImport } from 'type'
import { useBloomsLevel, useCompetency, useDifficultyLevels, useStandard } from 'utility/masterData'
import { availableLanguages } from 'utility/languages'
const { Text, Link } = Typography
const csvData = [paperTemplateImportFomart.map(item => item.toString())]
const { ExportOutlined } = Icons

const { Panel } = Collapse
type CreatePaperTemplateProps = {
  modalProps: ModalProps
  formProps: FormProps
  close: any
  // record: any;
}
interface SectionData {
  section_id: string
  sub_section_details: object[]
}
type AllQuestions = {
  question_count: number
  section_id: string
  total_mark: number
  index: any
  currentMark: number
}
type Details = {
  subject_id: any
  report_theme_id: any
  theme_id: any
  subtheme_id: any
  topic_id: any
  index: number
}
type SectionDetails = {
  section_name: string
  data: Details[]
}
type SectionTotal = {
  question_count: number
  section_id: string
  total_mark: number
}
export const CreatePaperTemplate: React.FC<CreatePaperTemplateProps> = ({ modalProps, formProps, close }) => {
  const { data: user } = useGetIdentity()
  const { mutate } = useCreateMany<IPaperTemplateSubSection>()
  let sub_section_arr: SectionData[] = []
  let submit = true
  const [showTestTrack, setShowTestTrack] = useState(false)
  const [formValues, setFormValues] = useState([{ id: '', value: 0 }])
  const [showSubjectData, setShowSubjectData] = useState(false)
  // const [subjectFilters, setSubjectFIlter] = useState<CrudFilter[]>([])
  const [selectedSubjects, setSelectedSubjects] = useState<SectionDetails[]>([])
  const [selectedThemes, setSelectedThemes] = useState<object[]>([])
  const [selectedSubThemes, setSelectedSubThemes] = useState<object[]>([])
  const [subSectionValues, setSubsSectionValues] = useState<object[]>([])
  const [themeList, setThemeList] = useState([] as any[])
  const [reportThemeList, setReportThemeList] = useState([] as any[])
  const [subThemeList, setSubThemeList] = useState([] as any[])
  const [topicList, setTopicList] = useState([] as any[])
  const [showSubSection, setShowSubSection] = useState(false)
  const [totalNoOfQuestions, setTotalNoOfQuestions] = useState(0)
  const [totalMarks, setTotalMarks] = useState(0)
  const [showError, setError] = useState(false)
  const [currentSection, setCurrentSection] = useState('')
  const [allQuestions, setAllQuestion] = useState<AllQuestions[]>([])
  const [sectionTotal, setSectionTotal] = useState<SectionTotal[]>([])
  const [subSectionCreatedBy, setsubSectionCreatedBy] = useState<'Create' | 'Upload' | null>()
  const [baseLanguage, setBaseLanguage] = useState()
  const questionTypes = ['MCQ', 'Fill', 'Match', 'ShortAnswer']

  const bloomlevelSelectProps = useBloomsLevel(modalProps?.visible)
  const difficultylevelSelectProps = useDifficultyLevels(modalProps?.visible)
  const competencyProps = useCompetency(modalProps?.visible)
  const standardProps = useStandard(modalProps?.visible)

  const { selectProps: questionTypeSelectProps } = useSelect<IQuestionType>({
    resource: 'question_types',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const [sectionListIds, setSectionListIds] = useState<string[]>([])
  const { filters, setFilters, tableQueryResult } = useTable({
    resource: 'products',
    metaData: {
      fields: ['id', 'sections', 'name', 'test_track_ids', 'total_questions', 'total_marks', 'type'],
    },
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const priorityList =
    tableQueryResult?.data?.data[0]?.type === 'jharkhand'
      ? [
          'Subject Expertise (SE)',
          'Pedagogical Content Knowledge (PCK)',
          'General Pedagogy (GP)',
          'Continuous and Comprehensive Evaluation (CCE)',
          'Teacher Perspectives and Professional Competencies (TP&PC)',
        ]
      : ['Subject Expertise (SE)', 'Pedagogical Content Knowledge (PCK)', 'General Pedagogy (GP)', 'Professional and core competencies (PC)']

  const clearSubSectionData = () => {
    const fields = formProps?.form?.getFieldsValue()
    sectionQueryResult?.data?.map((item: any, index: any) => {
      const section = fields[item?.name.toLowerCase().replaceAll(' ', '_')]
      if (section !== undefined) {
        Object.assign(section[0], {
          sub_section_name: null,
          subject_id: null,
          theme_id: null,
          report_theme_id: null,
          sub_theme_id: null,
          topic_id: null,
          no_of_questions: null,
          mark_per_question: null,
          question_type_id: null,
        })
        formProps?.form?.setFieldsValue({
          [item?.name.toLowerCase().replaceAll(' ', '_')]: section,
        })
      }
    })
  }

  const handleProductChange = (value: { value: any }) => {
    clearSubSectionData()
    formProps?.form?.setFieldsValue({
      test_track_id: null,
    })
    setFilters([
      {
        field: 'id',
        operator: 'eq',
        value: value,
      },
    ])
    setShowTestTrack(true)
  }

  const { data: sectionQueryResult, isLoading } = useMany<ISection>({
    resource: 'sections',
    ids: sectionListIds,
    metaData: {
      fields: ['id', 'name'],
    },
    queryOptions: { enabled: !!modalProps?.visible && sectionListIds?.length > 0 },
  })

  if (sectionQueryResult) {
    sectionQueryResult.data = sectionQueryResult?.data?.sort((a: any, b: any) => {
      const indexA = priorityList.indexOf(a.name)
      const indexB = priorityList.indexOf(b.name)
      return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB)
    })
  }
  // Define the type for the items
  // Define interface ProcessedItem and initialize allDetails and paperTDetails
  interface ProcessedItem {
    name: string
    section_id: string
    subject_id: string
    theme_id: string | null
    sub_theme_id: string | null
    topic_id: string | null
    no_of_questions: number
    mark_per_question: number
    question_type_id: string
    blooms_level_id: string | null
    difficult_level_id: string | null
    competency_id?: string | null
    strand_id?: string | null
    report_theme_id: string | null
    base_lang?: string | null
    target_lang?: string | null
  }

  // Initialize allDetails array and sectionSubsectionMap object
  let allDetails: ProcessedItem[] = []
  let sectionSubsectionMap: Map<string, string[]> = new Map()
  let uploadError = false

  // Modify the useImport function-------------------------------------
  const importProps = useImport<IPaperTemplateImport>({
    mapData: item => {
      if (!uploadError) {
        const isRowEmpty = (item: IPaperTemplateImport) => {
          return Object.values(item).every(field => field === '' || field === undefined)
        }
        // checking each fields in the object is empty or not
        const rowEmpty = isRowEmpty(item)

        if (!rowEmpty) {
          if (
            !item ||
            !item.sub_sec_name ||
            !item.subject_id ||
            !item.no_of_questions ||
            !item.mark_per_question ||
            !item.section_name ||
            !item.blooms_level_id ||
            !item.difficult_level_id
          ) {
            message.error('Import faild, required fields are missing while importing the csv file.')
            uploadError = true
            throw new Error('Required fields are missing in the imported item')
          }

          if (!questionTypes.includes(item.question_type_id)) {
            message.error('Invalid question type found')
            uploadError = true
            throw new Error('Invalid question type found')
          }

          const formDetails = formProps?.form?.getFieldsValue()
          const selectedTestTrack = testTrackQueryResult?.data?.data?.find(tt => tt.id === formDetails.test_track_id)

          // Check for test track retrieval
          if (!selectedTestTrack) {
            message.error('Test track details could not be retrieved. Please try again.')
            uploadError = true
            throw new Error('Test track details could not be retrieved.')
          }

          // Validate subject_id with test track
          if (!selectedTestTrack.subject_ids.includes(item.subject_id)) {
            // console.error(`Subject ID "${item.subject_id}" is not mapped to the selected Test Track ID "${formDetails.test_track_id}"`)
            uploadError = true
            message.error(
              `Subject ID "${item.subject_id}" is not mapped to the selected Test Track ID "${formDetails.test_track_id}". CSV file import aborted.`
            )
            return
          }

          // Create section map
          const sectionMap: { [key: string]: string } = {}
          sectionQueryResult?.data?.forEach(section => {
            sectionMap[section.name.toLowerCase()] = section.id
          })

          // Get section ID
          const sectionId = sectionMap[item?.section_name?.toLowerCase()]

          if (!sectionId) {
            // console.error(`Section name "${item?.section_name}" not found in section data`)
            message.error(`Section name "${item?.section_name}" not found in section data`)
            throw new Error(`Section name "${item?.section_name}" not found in section data`)
          }

          // Check for subsection name uniqueness
          if (!sectionSubsectionMap.has(sectionId)) {
            sectionSubsectionMap.set(sectionId, [])
          }
          const subsectionNames = sectionSubsectionMap.get(sectionId)!
          if (subsectionNames.includes(item.sub_sec_name)) {
            message.error(`Subsection name "${item.sub_sec_name}" is already used in section "${item.section_name}". CSV file import aborted.`)
            // Clear allDetails to ensure no invalid data is stored
            allDetails.length = 0
            return
          }

          const validTheme = themeList.find(theme => theme.subject_id === item.subject_id && theme.id === item.theme_id)
          const validSubTheme = subThemeList.find(theme => theme.theme_id === item.theme_id && theme.id === item.sub_theme_id)
          const validTopic = item.topic_id ? topicList.find(topic => topic.sub_theme.id === item.sub_theme_id && topic.id === item.topic_id) : true
          const validReportTheme = reportThemeList.find(reportTheme => {
            const cleanedThemeIds = Array.isArray(reportTheme?.theme_ids) ? reportTheme?.theme_ids?.filter(Boolean) : []
            const isValid = cleanedThemeIds.includes(item?.theme_id) && reportTheme?.id === item?.report_theme_id
            if (isValid) {
              return isValid
            }
          })
          const validBloomId = bloomlevelSelectProps?.options?.find(bloom => bloom?.value === item?.blooms_level_id)
          const validDifficultyId = difficultylevelSelectProps?.options?.find(difficulty => difficulty?.value === item?.difficult_level_id)
          //checking the competency and strand is valid or not if it present
          const validCompetency = item?.competency_id ? competencyProps?.options?.find(competency => competency?.value === item?.competency_id) : true
          const validStrand = item?.strand_id ? standardProps?.options?.find(strand => strand?.value === item.strand_id) : true

          if (!validBloomId || !validDifficultyId) {
            const errorMessage =
              !validBloomId && !validDifficultyId
                ? `Uploaded bloom level Id -${item.blooms_level_id} and difficulty level Id -${item.difficult_level_id} is not valid`
                : !validBloomId
                ? `Uploaded bloom level Id -${item.blooms_level_id} is invalid`
                : `Uploaded difficulty level Id -${item.difficult_level_id} is invalid`
            message.error(errorMessage)
            uploadError = true
            throw new Error(errorMessage)
          }

          if (item?.theme_id && !validTheme) {
            message.error(`Theme ID "${item.theme_id}" is not mapped to Subject ID "${item.subject_id}". CSV file import aborted.`)
            uploadError = true
            throw new Error(`Theme ID "${item?.theme_id}" is not mapped to Subject ID "${item?.subject_id}"`)
          }

          if (item.sub_theme_id && !validSubTheme) {
            message.error(`Sub Theme ID "${item.sub_theme_id}" is not mapped to Theme ID "${item.theme_id}". CSV file import aborted.`)
            uploadError = true
            throw new Error(`Sub Theme ID "${item.sub_theme_id}" is not mapped to Theme ID "${item.theme_id}"`)
          }

          if (!validTopic) {
            message.error(`Topic ID "${item.topic_id}" is not mapped to Sub Theme ID "${item.sub_theme_id}". CSV file import aborted.`)
            uploadError = true
            throw new Error(`Topic ID "${item.topic_id}" is not mapped to Sub Theme ID "${item.sub_theme_id}"`)
          }
          if (item.report_theme_id && !validReportTheme) {
            message.error(`Report Theme ID "${item.report_theme_id}" is not mapped to Theme ID "${item.theme_id}". CSV file import aborted.`)
            uploadError = true
            throw new Error(`Report Theme ID "${item.report_theme_id}" is not mapped to Theme ID "${item.theme_id}"`)
          }

          if ((item.competency_id && !validCompetency) || (item.strand_id && !validStrand)) {
            const errorMessage =
              !validCompetency && !validStrand
                ? `Uploaded competency Id -${item.competency_id} and strand Id -${item.strand_id} is not valid`
                : !validCompetency
                ? `Uploaded competencies Id -${item.competency_id} is invalid`
                : `Uploaded strand Id -${item.strand_id} is invalid`
            message.error(errorMessage)
            uploadError = true
            throw new Error(errorMessage)
          }

          if (item)
            // Add sub_sec_name to the array for this section_id
            subsectionNames.push(item.sub_sec_name)

          const processedItem: ProcessedItem = {
            name: item?.sub_sec_name,
            section_id: sectionId,
            subject_id: item?.subject_id,
            theme_id: item?.theme_id || null,
            sub_theme_id: item?.sub_theme_id || null,
            topic_id: item?.topic_id || null,
            no_of_questions: item?.no_of_questions,
            mark_per_question: item?.mark_per_question,
            question_type_id: item?.question_type_id,
            blooms_level_id: item?.blooms_level_id,
            difficult_level_id: item?.difficult_level_id,
            strand_id: item?.strand_id || null,
            competency_id: item?.competency_id || null,
            report_theme_id: item?.report_theme_id || null,
            base_lang: item?.base_lang || null,
            target_lang: item?.target_lang || null,
          }

          // Push the processed item into the array of all processed items
          allDetails.push(processedItem)
        }
      }
    },
    onFinish: async () => {
      try {
        const formDetails = formProps?.form?.getFieldsValue()

        // Check if required fields are present
        if (!formDetails?.name || !formDetails?.product_id || !formDetails?.test_track_id) {
          message.error('Name, Product ID, and Test Track ID are required fields.')
          throw new Error('Name, Product ID, and Test Track ID are required fields.')
        }

        // Check if allDetails is populated correctly
        if (allDetails.length === 0) {
          console.error('No valid data to process. Aborting onFinish function.')
          message.error('No valid data to process. Aborting operation.')
          return
        }

        const ptDetails = tableQueryResult?.data?.data
        if (!ptDetails) {
          throw new Error('No data available in tableQueryResult')
        }

        // Call the helper function with proper type assertion
        const isMarkFine = await checkMarkWithSectionTotal(ptDetails as any[], allDetails)
        if (isMarkFine.status === false) {
          message.error(isMarkFine.message ? isMarkFine.message : 'Something went wrong...')
          uploadError = true
          // throw new Error('Marks and Questions do not match with the Total Marks and Questions')
        }
        const complete = isMarkFine.status
        if (complete && !uploadError) {
          if (formProps.onFinish) {
            const isCompleted = isMarkFine.flag === 1 ? true : false
            await formProps?.onFinish({
              name: formDetails?.name,
              description: formDetails?.description,
              product_id: formDetails?.product_id,
              test_track_id: formDetails?.test_track_id,
              status: '',
              sections: sectionListIds,
              created_by: user?.id,
              is_completed: isCompleted,
            })

            const paperTemplateId: any = await getLastCreatedPaperTemplate()

            const extractedPaperTemplateId = paperTemplateId?.paper_templates[0]?.id

            if (!extractedPaperTemplateId) {
              message.error('Unable to find the extracted paperTemplateId, Please try again ')
              return
            }

            const modifiedSubsections = allDetails.map(subsection => ({
              ...subsection,
              paper_template_id: extractedPaperTemplateId,
            }))

            // Perform mutation to store data in the database
            await mutate({
              resource: 'paper_template_sub_sections',
              values: modifiedSubsections,
            })

            message.success('Paper Template upload completed successfully...')
          }
        }
      } catch (error) {
        console.error('Error in onFinish:', error)
        message.error('Error occurred during import or completion process. Please check logs for details.')
      }
    },
  })
  //--------------------------------------------

  useEffect(() => {
    setSectionTotal([])
    setSelectedSubjects([])
    let arr: string[] = []
    let selected: SectionDetails[] = []
    tableQueryResult?.data?.data?.map((item: any) => {
      item?.sections?.map((section: any) => {
        arr.push(section?.section_id)
      })
    })
    arr = arr.filter((item, idx) => arr.indexOf(item) === idx)
    setSectionListIds(arr)
    sectionQueryResult?.data?.map((item: any) => {
      if (arr.includes(item?.id)) {
        selected.push({
          section_name: item?.name.toLowerCase().replaceAll(' ', '_'),
          data: [],
        })
      }
    })
    setSelectedSubjects(selected)
  }, [tableQueryResult.data?.data, sectionQueryResult?.data])

  const { selectProps: testtrackSelectProps } = useSelect<ITestTrack>({
    resource: 'test_tracks',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 100,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    filters: [
      {
        field: 'id',
        operator: 'in',
        value: tableQueryResult?.data?.data[0]?.test_track_ids ?? [],
      },
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const { selectProps: reportThemeProps, queryResult: reportThemeQueryResult } = useSelect<IReportTheme>({
    resource: 'report_themes',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 10000,
    metaData: {
      fields: ['id', 'name', 'topic_ids', 'theme_ids'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      {
        field: 'theme_ids',
        operator: 'nnull',
        value: true,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],

    queryOptions: { enabled: !!modalProps?.visible },
  })
  const { setFilters: setTestTrackFilters, tableQueryResult: testTrackQueryResult } = useTable<ITestTrack>({
    resource: 'test_tracks',
    metaData: {
      fields: ['subject_ids', 'id', 'name'],
    },
    initialPageSize: 10000000,
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const { setFilters: setSubjectFilter, tableQueryResult: subjectkQueryResult } = useTable<ISubject>({
    resource: 'subjects',
    metaData: {
      fields: ['id', 'name'],
    },
    initialPageSize: 10000000,
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const handleSubjectChange = (value: { value: any }, key: any, name: string) => {
    setCurrentSection(name)
    let arr: SectionDetails[] = [...selectedSubjects]
    var found = arr.findIndex(function (element: any) {
      return element?.section_name === name
    })
    if (found !== -1) {
      let data_found = arr[found]?.data?.findIndex(function (element: any) {
        return element?.index === key
      })
      // console.log('data_found', data_found)
      if (data_found !== -1) {
        arr[found].data[data_found]['subject_id'] = value
      } else {
        arr[found]?.data.push({
          index: key,
          subject_id: value,
          report_theme_id: '',
          theme_id: '',
          subtheme_id: '',
          topic_id: '',
        })
      }
    }
    const fields = formProps?.form?.getFieldsValue()
    const section = fields[name]

    Object.assign(section[key], { report_theme_id: null, theme_id: null, sub_theme_id: null, topic_id: null })
    formProps?.form?.setFieldsValue({
      [name]: section,
    })
    setSelectedSubjects(arr)
  }

  const handleReportThemeChange = (value: { value: any }, key: any, name: string) => {
    let arr: SectionDetails[] = [...selectedSubjects]
    var found = arr.findIndex(function (element: any) {
      return element?.section_name === name
    })
    if (found !== -1) {
      let data_found = arr[found]?.data?.findIndex(function (element: any) {
        return element?.index === key
      })
      // console.log('data_found', data_found)
      if (data_found !== -1) {
        arr[found].data[data_found]['report_theme_id'] = value
      }
    }

    const fields = formProps?.form?.getFieldsValue()
    const section = fields[name]

    Object.assign(section[key], { theme_id: null, sub_theme_id: null, topic_id: null })
    formProps?.form?.setFieldsValue({
      [name]: section,
    })
    setSelectedSubjects(arr)
  }
  // console.log('selected_subject', selectedSubjects)
  const handleThemeChange = (value: { value: any }, key: any, name: string) => {
    let arr: SectionDetails[] = [...selectedSubjects]
    var found = arr.findIndex(function (element: any) {
      return element?.section_name === name
    })
    if (found !== -1) {
      let data_found = arr[found]?.data?.findIndex(function (element: any) {
        return element?.index === key
      })
      // console.log('data_found', data_found)
      if (data_found !== -1) {
        arr[found].data[data_found]['theme_id'] = value
      }
    }

    const fields = formProps?.form?.getFieldsValue()
    const section = fields[name]

    Object.assign(section[key], { sub_theme_id: null, topic_id: null, report_theme_id: null })
    formProps?.form?.setFieldsValue({
      [name]: section,
    })
    setSelectedSubjects(arr)
  }
  const handleSubThemeChange = (value: { value: any }, key: any, name: string) => {
    setCurrentSection(name)
    let arr: SectionDetails[] = [...selectedSubjects]
    var found = arr.findIndex(function (element: any) {
      return element?.section_name === name
    })
    if (found !== -1) {
      let data_found = arr[found]?.data?.findIndex(function (element: any) {
        return element?.index === key
      })
      if (data_found !== -1) {
        arr[found].data[data_found]['subtheme_id'] = value
      }
    }

    const fields = formProps?.form?.getFieldsValue()
    const section = fields[name]
    Object.assign(section[key], { topic_id: null })
    formProps?.form?.setFieldsValue({
      [name]: section,
    })
    setSelectedSubjects(arr)
  }

  const handleTopicChange = (value: { value: any }, key: any, name: string) => {
    setCurrentSection(name)
    let arr: SectionDetails[] = [...selectedSubjects]
    var found = arr.findIndex(function (element: any) {
      return element?.section_name === name
    })
    if (found !== -1) {
      let data_found = arr[found]?.data?.findIndex(function (element: any) {
        return element?.index === key
      })
      if (data_found !== -1) {
        arr[found].data[data_found]['topic_id'] = value
      }
    }
    const fields = formProps?.form?.getFieldsValue()

    const section = fields[name]
    // Object.assign(section[key], { report_theme_id: null })
    formProps?.form?.setFieldsValue({
      [name]: section,
    })
    const Newfields = formProps?.form?.getFieldsValue()

    setSelectedSubjects(arr)
  }

  const { selectProps: productSelectProps } = useSelect<IProduct>({
    resource: 'products',
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    filters: [{ field: 'active', operator: 'eq', value: 'true' }],
    fetchSize: 100,
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const addSubsection = (id: string) => {
    let newFormValues = [...formValues]
    var found = newFormValues.findIndex(function (element: any) {
      return element?.id === id
    })
    if (found !== -1) {
      newFormValues[found].value = newFormValues[found].value + 1
      setFormValues(newFormValues)
    } else {
      // arr.push({ id: id, value: 1 })
      setFormValues([...formValues, { id: id, value: 1 }])
      // setFormValues(data.concat(arr));
    }
    // setFormValues([...formValues, { id: "", value: "" }])
  }

  const handleTestTrackChange = (value: { value: any }) => {
    clearSubSectionData()
    setTestTrackFilters([
      {
        field: 'id',
        operator: 'eq',
        value: value,
      },
    ])

    setShowSubSection(true)
    // getSubjectByTestTrack()
  }

  useEffect(() => {
    if (JSON.stringify(testTrackQueryResult?.data?.data[0]?.subject_ids) !== '{}') {
      setSubjectFilter([
        {
          field: 'id',
          operator: 'in',
          value: testTrackQueryResult?.data?.data[0]?.subject_ids ?? [],
        },
      ])

      if (testTrackQueryResult?.data?.data[0]?.subject_ids !== null) {
        setShowSubjectData(true)
      }
      // setShowSubSection(true)
    } else {
      setShowSubjectData(false)
      // setShowSubSection(false)
    }
  }, [testTrackQueryResult?.data?.data])

  useEffect(() => {
    setThemeList([])
    setReportThemeList([])
    setSubThemeList([])
    setTopicList([])

    if (JSON.stringify(testTrackQueryResult?.data?.data[0]?.subject_ids) !== '{}') {
      getReportThemeDataBySubjects(JSON.stringify(testTrackQueryResult?.data?.data[0]?.subject_ids)).then((resp: any) => {
        // setReportThemeList([])
        setReportThemeList(resp?.report_themes)
      })
      getThemeDataBySubjects(JSON.stringify(testTrackQueryResult?.data?.data[0]?.subject_ids)).then((resp: any) => {
        // setThemeList([])
        setThemeList(resp?.themes)
      })
      getSubThemeBySubjects(JSON.stringify(testTrackQueryResult?.data?.data[0]?.subject_ids)).then((resp: any) => {
        setSubThemeList(resp?.sub_themes)
      })
      getTopicBySubjects(JSON.stringify(testTrackQueryResult?.data?.data[0]?.subject_ids)).then((resp: any) => {
        setTopicList(resp?.topics)
      })
    }
  }, [testTrackQueryResult?.data?.data[0]?.subject_ids])

  const onFinish = async (values: any) => {
    let break_stmt: number = -1
    if (tableQueryResult?.data?.data[0]?.sections?.length !== sectionTotal.length) {
      break_stmt = 0
    } else {
      tableQueryResult?.data?.data[0]?.sections?.map((data: any) =>
        sectionTotal?.map((total: any) => {
          if (data?.section_id === total?.section_id) {
            if (break_stmt == 0) {
              return
            }

            if (total?.question_count == parseInt(data?.no_of_questions) && total?.total_mark == parseInt(data?.marks)) {
              break_stmt = 1
            } else {
              break_stmt = 0
              return
            }
          }
        })
      )
    }

    if (showError === false) {
      return (
        formProps.onFinish &&
        formProps.onFinish({
          name: values?.name,
          description: values?.description,
          product_id: values?.product_id,
          test_track_id: values?.test_track_id,
          status: '',
          sections: sectionListIds,
          created_by: user?.id,
          is_completed: break_stmt === 1 ? true : false,
        })
      )
    }
  }

  const setTotalQuestion = (section_id: string, value: any, type: string, index: any) => {
    let arr = [...allQuestions]
    let section_tot = [...sectionTotal]
    let found = arr.findIndex((elem: any) => elem?.section_id === section_id && elem?.index === index)
    if (found === -1) {
      if (type === 'no_of_questions') {
        arr.push({
          section_id: section_id,
          question_count: value,
          total_mark: 0,
          index: index,
          currentMark: 0,
        })
      } else {
        arr.push({
          section_id: section_id,
          question_count: 0,
          total_mark: value,
          index: index,
          currentMark: value,
        })
      }
    } else {
      let currentMark = arr[found]['currentMark']
      if (type === 'no_of_questions') {
        if (!isNaN(value)) {
          arr[found]['question_count'] = value
          arr[found]['total_mark'] = currentMark * value
        }
      } else {
        if (!isNaN(value)) {
          arr[found]['total_mark'] = arr[found]['question_count'] * value
          arr[found]['currentMark'] = value
        }
      }
    }
    let total_question = 0,
      total_mark = 0
    sectionQueryResult?.data?.map((item: any, index: any) => {
      let section_name = item?.name.toLowerCase().replaceAll(' ', '_')
      const fields = formProps?.form?.getFieldsValue()
      const section = fields[section_name]
      if (section !== undefined) {
        section?.map((data: any) => {
          if (data?.section_id === section_id) {
            total_question = total_question + parseInt(data?.no_of_questions)
            total_mark = total_mark + parseInt(data?.mark_per_question) * parseInt(data?.no_of_questions)
          }
        })
        let foundSection = section_tot.findIndex((elem: any) => elem?.section_id === section_id)
        if (foundSection === -1) {
          section_tot.push({
            section_id: section_id,
            total_mark: !isNaN(total_mark) ? total_mark : 0,
            question_count: !isNaN(total_question) ? total_question : 0,
          })
        } else {
          section_tot[foundSection]['total_mark'] = !isNaN(total_mark) ? total_mark : 0
          section_tot[foundSection]['question_count'] = !isNaN(total_question) ? total_question : 0
        }
      }
    })

    setAllQuestion(arr)
    setSectionTotal(section_tot)
  }

  useEffect(() => {
    let break_stmt: boolean = false

    tableQueryResult?.data?.data[0]?.sections?.map((data: any) =>
      sectionTotal?.map((total: any) => {
        if (data?.section_id === total?.section_id) {
          if (break_stmt) {
            return
          }

          if (total?.question_count > parseInt(data?.no_of_questions)) {
            break_stmt = true

            return
          } else if (total?.total_mark > parseInt(data?.marks)) {
            break_stmt = true

            return
          } else if (total?.question_count <= parseInt(data?.no_of_questions) && total?.total_mark <= parseInt(data?.marks)) {
            break_stmt = false
          }
        }
      })
    )
    setError(break_stmt)
  }, [sectionTotal])
  const removeSection = (section_name: string, section_id: string, key: any) => {
    let section_tot = [...sectionTotal]
    let arr = [...allQuestions]
    let new_arr: AllQuestions[] = []
    let result = arr.filter((elem: any) => elem?.section_id === section_id && elem?.index !== key)
    let result1 = arr.filter((elem: any) => elem?.section_id !== section_id && elem?.index !== key)
    if (result.length > 0) {
      result?.map((item: any) => {
        new_arr.push(item)
      })
    }
    if (result1.length > 0) {
      result1?.map((item: any) => {
        new_arr.push(item)
      })
    }
    let foundSection = section_tot.findIndex((elem: any) => elem?.section_id === section_id)
    let total_questions = 0
    let total_mark = 0
    new_arr?.map((item: any) => {
      if (item?.section_id === section_id) {
        total_questions = total_questions + item?.question_count
        total_mark = total_mark + item?.total_mark
      }
    })
    if (foundSection === -1) {
      section_tot.push({
        total_mark: total_mark,
        section_id: section_id,
        question_count: total_questions,
      })
    } else {
      section_tot[foundSection]['question_count'] = total_questions
      section_tot[foundSection]['total_mark'] = total_mark
    }
    setAllQuestion(new_arr)
    setSectionTotal(section_tot)
  }

  return (
    <Modal
      {...modalProps}
      title="Create Paper Template"
      onCancel={() => {
        clearSubSectionData()
        formProps?.form?.resetFields()
        setShowTestTrack(false)
        setSectionTotal([])
        setSelectedSubjects([])
        setReportThemeList([])
        setThemeList([])
        setSubThemeList([])
        setTopicList([])
        setShowSubSection(false)
        setShowSubjectData(false)
        close()
      }}
      afterClose={() => {
        // clearSubSectionData()
        formProps?.form?.resetFields()
        // setShowSubSection(false)
        setShowTestTrack(false)
      }}
      okButtonProps={{ disabled: showError || subSectionCreatedBy === 'Upload', onClick: () => formProps?.form?.submit() }}
    >
      <Form
        {...formProps}
        layout="vertical"
        onFinish={values =>
          onFinish(values).then(() => {
            if (showError === false) {
              let paper_template_id = ''
              let arr: object[] = []
              formProps.form?.resetFields()
              getLastCreatedPaperTemplate().then((resp: any) => {
                paper_template_id = resp?.paper_templates[0]?.id

                sectionQueryResult?.data?.map(item => {
                  if (JSON.stringify(values[item?.name.toLowerCase().replaceAll(' ', '_')])) {
                    values[item?.name.toLowerCase().replaceAll(' ', '_')]?.map((elem: any) => {
                      console.log(elem, 'each element')
                      arr.push({
                        // sub_section_id: uuidv4(),
                        name: elem?.sub_section_name,
                        section_id: item?.id,
                        paper_template_id: paper_template_id,
                        subject_id: elem?.subject_id,
                        theme_id: elem?.theme_id,
                        sub_theme_id: elem?.sub_theme_id,
                        topic_id: elem?.topic_id,
                        no_of_questions: elem?.no_of_questions,
                        mark_per_question: elem?.mark_per_question,
                        question_type_id: elem?.question_type_id,
                        report_theme_id: elem?.report_theme_id,
                        difficult_level_id: elem?.difficulty_level_id,
                        blooms_level_id: elem?.blooms_level_id,
                        strand_id: elem?.strand_id,
                        competency_id: elem?.competency_id,
                        base_lang: elem?.base_lang || null,
                        target_lang: elem?.target_lang || null,
                      })
                    })
                  }
                })
                console.log(arr, 'array of sub section upload is this')
                mutate({
                  resource: 'paper_template_sub_sections',
                  values: arr,
                })
                setShowSubSection(false)
                // let found= arr.findIndex((data:any)=>data.section_id===item?.id)
              })
            } else {
              setError(true)
            }
          })
        }
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Please enter a Paper Template Name',
                },
              ]}
            >
              <Input placeholder="PaperTemplate Name" />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Product" name="product_id" rules={[{ required: true }]}>
              <Select {...productSelectProps} onChange={handleProductChange} allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input placeholder="Description" type="small" />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Test Track" name="test_track_id" rules={[{ required: true }]}>
              <Select {...testtrackSelectProps} onChange={handleTestTrackChange} disabled={!showTestTrack} />
            </Form.Item>
          </Col>
        </Row>
        {showSubSection ? (
          <Row>
            <Col xs={24} lg={24}>
              <h3>Paper Format (Framework)</h3>
              <p>
                You can either create the framework manually or you can import a file containing all the framework details.
                <a key="export paper" type="default" style={{ marginLeft: '10px' }}>
                  <CSVLink key="export" data={csvData} filename={`paperTemplateImportFormat${Math.round(new Date().getTime() / 1000)}`}>
                    <ExportOutlined /> Get import format
                  </CSVLink>
                </a>
              </p>

              {/* section creation for selecting  sub section */}
              <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                <Radio.Group
                  size="middle"
                  defaultValue={subSectionCreatedBy}
                  onChange={e => {
                    setsubSectionCreatedBy(e.target.value)
                  }}
                >
                  <Radio.Button value="Create">Create</Radio.Button>
                  <Radio.Button value="Upload">Upload</Radio.Button>
                </Radio.Group>
              </div>

              {subSectionCreatedBy === 'Create' && (
                <Collapse defaultActiveKey={['1']}>
                  {sectionQueryResult?.data?.map((item: any, index: any) => (
                    <Panel header={item?.name} key={item?.id}>
                      <Form.List name={item?.name.toLowerCase().replaceAll(' ', '_')}>
                        {(fields, { add, remove }) => (
                          <>
                            {fields.map(({ key, name, ...restField }) => (
                              <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                <Row gutter={[16, 0]}>
                                  <Col xs={24} lg={3}>
                                    <Form.Item
                                      {...restField}
                                      name={[name, 'sub_section_name']}
                                      rules={[{ required: true, message: 'Please enter a Sub-Section Name' }]}
                                    >
                                      <Input placeholder="Name" type="small" />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} lg={3}>
                                    <Form.Item
                                      {...restField}
                                      name={[name, 'subject_id']}
                                      rules={[{ required: true, message: 'Please select a Subject' }]}
                                    >
                                      <Select
                                        showSearch
                                        placeholder="Subject"
                                        onChange={value => handleSubjectChange(value, key, item?.name.toLowerCase().replaceAll(' ', '_'))}
                                        filterOption={(input, option) => {
                                          if (option && option.children) {
                                            return option.children.toString().toLowerCase().includes(input.toLowerCase())
                                          }
                                          return false
                                        }}
                                        optionFilterProp="children"
                                      >
                                        {showSubjectData &&
                                          subjectkQueryResult?.data?.data?.map((item: any) => <option value={item?.id}>{item?.name}</option>)}
                                      </Select>
                                    </Form.Item>
                                  </Col>

                                  <Col xs={24} lg={3}>
                                    <Form.Item
                                      {...restField}
                                      name={[name, 'theme_id']}
                                      rules={[{ required: true, message: 'Please select a Theme' }]}
                                    >
                                      <Select
                                        placeholder="Theme"
                                        onChange={value => handleThemeChange(value, key, item?.name.toLowerCase().replaceAll(' ', '_'))}
                                        showSearch
                                        filterOption={(input, option) => {
                                          if (option && option.children) {
                                            return option.children.toString().toLowerCase().includes(input.toLowerCase())
                                          }
                                          return false
                                        }}
                                        optionFilterProp="children"
                                      >
                                        {themeList !== undefined &&
                                          themeList?.length > 0 &&
                                          themeList.map((themes: any) =>
                                            selectedSubjects.length > 0 ? (
                                              selectedSubjects.map((elem: any, i: any) =>
                                                elem?.section_name === item?.name.toLowerCase().replaceAll(' ', '_')
                                                  ? elem?.data?.map((data: Details) =>
                                                      data?.index === key && data?.subject_id === themes?.subject_id ? (
                                                        <>
                                                          <option key={themes?.id} value={themes?.id}>
                                                            {themes?.name}
                                                          </option>
                                                        </>
                                                      ) : null
                                                    )
                                                  : // <></>
                                                    null
                                              )
                                            ) : (
                                              <option key={themes.id} value={themes.id}>
                                                {themes.name}
                                              </option>
                                            )
                                          )}
                                      </Select>
                                    </Form.Item>{' '}
                                  </Col>
                                  {/* _______________________________________________RT */}
                                  <Col xs={24} lg={3}>
                                    <Form.Item
                                      {...restField}
                                      name={[name, 'report_theme_id']}
                                      rules={[{ required: true, message: 'Please select a Report Theme' }]}
                                    >
                                      <Select
                                        placeholder="Report Theme"
                                        showSearch
                                        filterOption={(input, option) => {
                                          if (option && option.children) {
                                            return option.children.toString().toLowerCase().includes(input.toLowerCase())
                                          }
                                          return false
                                        }}
                                        optionFilterProp="children"
                                      >
                                        {reportThemeQueryResult?.data?.data !== undefined &&
                                          reportThemeQueryResult?.data?.data?.length > 0 &&
                                          reportThemeQueryResult?.data?.data.map((reportThemes: any) => {
                                            let fieldName = item?.name.toLowerCase().replaceAll(' ', '_')
                                            let fieldValue = formProps?.form?.getFieldValue([fieldName])
                                            let themeId = fieldValue[name]?.theme_id
                                            if (themeId && Array.isArray(reportThemes?.theme_ids) && reportThemes?.theme_ids?.includes(themeId)) {
                                              return (
                                                <option key={reportThemes.id} value={reportThemes.id}>
                                                  {reportThemes.name}
                                                </option>
                                              )
                                            }
                                          })}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                  {/* ________________________________________________RT */}
                                  <Col xs={24} lg={3}>
                                    <Form.Item
                                      {...restField}
                                      name={[name, 'sub_theme_id']}
                                      rules={[{ required: true, message: 'Please select a Sub Theme' }]}
                                    >
                                      <Select
                                        placeholder="Sub Theme"
                                        onChange={value => handleSubThemeChange(value, key, item?.name.toLowerCase().replaceAll(' ', '_'))}
                                        showSearch
                                        filterOption={(input, option) => {
                                          if (option && option.children) {
                                            return option.children.toString().toLowerCase().includes(input.toLowerCase())
                                          }
                                          return false
                                        }}
                                        optionFilterProp="children"
                                      >
                                        {subThemeList !== undefined &&
                                          subThemeList?.length > 0 &&
                                          subThemeList.map((subtheme: any) =>
                                            selectedSubjects.length > 0 ? (
                                              selectedSubjects.map((elem: any, i: any) =>
                                                elem?.section_name === item?.name.toLowerCase().replaceAll(' ', '_')
                                                  ? elem?.data?.map((data: Details) =>
                                                      data?.index === key && data?.theme_id === subtheme?.theme?.id ? (
                                                        <>
                                                          <option key={subtheme?.id} value={subtheme?.id}>
                                                            {subtheme?.name}
                                                          </option>
                                                        </>
                                                      ) : null
                                                    )
                                                  : null
                                              )
                                            ) : (
                                              <option key={subtheme.id} value={subtheme.id}>
                                                {subtheme.name}
                                              </option>
                                            )
                                          )}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} lg={3}>
                                    <Form.Item
                                      {...restField}
                                      name={[name, 'topic_id']}
                                      // rules={[{ required: true, message: 'Please select a Topic' }]}
                                    >
                                      <Select
                                        placeholder="Topic"
                                        onChange={value => handleTopicChange(value, key, item?.name.toLowerCase().replaceAll(' ', '_'))}
                                        showSearch
                                        filterOption={(input, option) => {
                                          if (option && option.children) {
                                            return option.children.toString().toLowerCase().includes(input.toLowerCase())
                                          }
                                          return false
                                        }}
                                        optionFilterProp="children"
                                      >
                                        {topicList !== undefined &&
                                          topicList?.length > 0 &&
                                          topicList.map((topic: any) =>
                                            selectedSubjects.length > 0 ? (
                                              selectedSubjects.map((elem: any, i: any) =>
                                                elem?.section_name === item?.name.toLowerCase().replaceAll(' ', '_')
                                                  ? elem?.data?.map((data: Details) =>
                                                      data?.index === key && data?.subtheme_id === topic?.sub_theme?.id ? (
                                                        <>
                                                          <option key={topic?.id} value={topic?.id}>
                                                            {topic?.name}
                                                          </option>
                                                        </>
                                                      ) : null
                                                    )
                                                  : null
                                              )
                                            ) : (
                                              <option key={topic.id} value={topic.id}>
                                                {topic.name}
                                              </option>
                                            )
                                          )}
                                      </Select>
                                    </Form.Item>
                                  </Col>

                                  <Col xs={24} lg={3}>
                                    <Form.Item
                                      {...restField}
                                      name={[name, 'blooms_level_id']}
                                      rules={[{ required: true, message: 'Please select a Bloom Level' }]}
                                    >
                                      <Select {...bloomlevelSelectProps} placeholder="Blooms Level" />
                                    </Form.Item>
                                  </Col>

                                  <Col xs={24} lg={3}>
                                    <Form.Item
                                      {...restField}
                                      name={[name, 'difficulty_level_id']}
                                      rules={[{ required: true, message: 'Please select a Difficulty Level' }]}
                                    >
                                      <Select {...difficultylevelSelectProps} placeholder="Difficulty Level" />
                                    </Form.Item>
                                  </Col>

                                  <Col xs={24} lg={3}>
                                    <Form.Item {...restField} name={[name, 'competency_id']} rules={[{ required: false }]}>
                                      <Select {...competencyProps} placeholder="Competency" />
                                    </Form.Item>
                                  </Col>

                                  <Col xs={24} lg={3}>
                                    <Form.Item {...restField} name={[name, 'strand_id']} rules={[{ required: false }]}>
                                      <Select {...standardProps} placeholder="Standard" />
                                    </Form.Item>
                                  </Col>

                                  <Col xs={24} lg={3}>
                                    <Form.Item
                                      {...restField}
                                      name={[name, 'question_type_id']}
                                      rules={[{ required: true, message: 'Please select a Question Type' }]}
                                    >
                                      <Select {...questionTypeSelectProps} placeholder="Question Type" />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} lg={3}>
                                    <Form.Item
                                      {...restField}
                                      name={[name, 'no_of_questions']}
                                      rules={[{ required: true, message: 'Please enter the count of Questions for this combination' }]}
                                    >
                                      <Input
                                        placeholder="Count"
                                        type="small"
                                        onChange={e => {
                                          setTotalQuestion(item?.id, parseInt(e.target.value), 'no_of_questions', key)
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} lg={3}>
                                    <Form.Item
                                      {...restField}
                                      name={[name, 'mark_per_question']}
                                      rules={[{ required: true, message: 'Please enter marks of each question' }]}
                                    >
                                      <Input
                                        placeholder="Mark per Question"
                                        type="small"
                                        onChange={e => {
                                          setTotalQuestion(item?.id, parseInt(e.target.value), 'mark_per_question', key)
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>
                                  {/* ----------------Base Language------------- */}
                                  <Col xs={24} lg={3}>
                                    <Form.Item {...restField} name={[name, 'base_lang']}>
                                      <Select
                                        placeholder="Base Language"
                                        onChange={value => {
                                          setBaseLanguage(value)
                                          formProps?.form?.setFieldsValue({
                                            target_lang: null,
                                          })
                                        }}
                                        allowClear
                                      >
                                        {availableLanguages.map(lang => (
                                          <option key={lang.label} value={lang.value}>
                                            {lang.label}
                                          </option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                  {/* ------------------Target language */}
                                  <Col xs={24} lg={3}>
                                    <Form.Item {...restField} name={[name, 'target_lang']}>
                                      <Select placeholder="Target Language" allowClear>
                                        {availableLanguages.map(lang => {
                                          if (baseLanguage !== lang.value) {
                                            return (
                                              <option key={lang.label} value={lang.value}>
                                                {lang.label}
                                              </option>
                                            )
                                          }
                                        })}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                  {/* ------------------------------ */}
                                  <Col xs={24} lg={3}>
                                    <Form.Item name={[name, 'section_id']} initialValue={item?.id}>
                                      <Input type="hidden" />
                                    </Form.Item>
                                  </Col>
                                </Row>
                                <MinusCircleOutlined
                                  onClick={() => {
                                    remove(name)
                                    removeSection(item?.name.toLowerCase().replaceAll(' ', '_'), item?.id, key)
                                  }}
                                />
                              </Space>
                            ))}
                            {showTestTrack ? (
                              <Descriptions size="small" column={2}>
                                {tableQueryResult?.data?.data[0]?.sections?.map((data: any) => (
                                  <>
                                    {data?.section_id === item?.id ? (
                                      <>
                                        <Descriptions.Item label="No of questions requested">{data?.no_of_questions}</Descriptions.Item>
                                        <Descriptions.Item label="Total marks requested">{data?.marks}</Descriptions.Item>
                                      </>
                                    ) : null}
                                  </>
                                ))}
                              </Descriptions>
                            ) : null}
                            {tableQueryResult?.data?.data[0]?.sections?.map((data: any) =>
                              sectionTotal?.map((total: any) =>
                                data?.section_id === item?.id && total?.section_id === data?.section_id ? (
                                  <>
                                    {total?.question_count > parseInt(data?.no_of_questions) ? (
                                      <>
                                        {' '}
                                        <Text type="danger">Limit Exceeded!!!Questions requested is {data?.no_of_questions} </Text>
                                        <br />
                                      </>
                                    ) : null}
                                    {total?.total_mark > parseInt(data?.marks) ? (
                                      <Text type="danger">Limit Exceeded!!!Total marks requested is {data?.marks} </Text>
                                    ) : null}
                                  </>
                                ) : null
                              )
                            )}
                            {/* <Text type="danger">Ant Design (danger)</Text> */}
                            <Form.Item>
                              <Button
                                type="dashed"
                                onClick={() => {
                                  add()
                                }}
                                block
                                icon={<PlusOutlined />}
                              >
                                Add Subsection
                              </Button>
                            </Form.Item>
                          </>
                        )}
                      </Form.List>
                    </Panel>
                  ))}
                </Collapse>
              )}
              {subSectionCreatedBy === 'Upload' && (
                <div
                  style={{
                    width: '100%',
                    height: '80px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: 'linear-gradient(83deg, rgba(238,238,238,1) 37%, rgba(228,228,228,1) 100%)',
                    borderRadius: '10px',
                    marginTop: '10px',
                  }}
                >
                  <ImportButton
                    {...importProps}
                    buttonProps={{
                      type: 'text',
                      style: { width: '100%' },
                    }}
                  />
                </div>
              )}

              <Form.Item name="created_by" initialValue={'user-id'}>
                <Input type="hidden" />
              </Form.Item>
            </Col>
          </Row>
        ) : null}
      </Form>
    </Modal>
  )
}
